/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useMemo } from "react";
import { Badge, Button, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CircleX } from "lucide-react";

import { Paths } from "../../routes/paths";
import { useUser } from "../../hooks/use-user";

export default function NotificationsFilterBar({ getList, onExport }) {
  const user = useUser();
  const [filters, setFilters] = useState({});
  const [filter, setFilter] = useState("");
  const filterTimeout = useRef(null);

  useEffect(() => {
    getList(filter || "");
  }, []);

  useEffect(() => {
    filterTimeout.current = setTimeout(() => {
      getList(filter || "");
      handleAddFilter("filter", filter, "Search");
    }, 1000);
    return () => clearTimeout(filterTimeout.current);
  }, [filter]);

  const handleAddFilter = (key, value, name) => {
    if (!value) {
      handleClearFilter(key);
      return;
    }
    setFilters((prev) => ({ ...prev, [key]: `${name}: ${value}` }));
  };

  const handleClearFilter = (key) => {
    const updated = { ...filters };
    delete updated[key];
    if (key === "filter") setFilter("");
    setFilters(updated);
  };

  const clearAllFilters = () => {
    setFilter("");
    setFilters({});
  };

  return (
    <>
      <div className="flex mb-3 gap-1">
        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search"
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
        <div className="flex gap-2">
          <Button variant="secondary">
            <Link to={Paths.addNotification}>Create Notification Rule</Link>
          </Button>
          <Button variant="secondary" onClick={onExport}>
            Export
          </Button>
        </div>
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            key={key}
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
          >
            {value}
            <CircleX onClick={() => handleClearFilter(key)} />
          </Badge>
        ))}
        {Object.keys(filters).length > 0 && (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX onClick={clearAllFilters} />
          </Badge>
        )}
      </div>
    </>
  );
}
